/* eslint-disable import/no-duplicates */

import { useScheduling } from 'hooks/useScheduling'
import { useBrand } from 'hooks/useBrand'
import { useTokenApi } from 'hooks/useTokenApi'
import { ArrowLeft } from 'lucide-react'

import Resume from './Resume'
import BillingAddress from './BillingAddress'
import PaymentMethod from './PaymentMethod'

import TextDanger from 'new-components/partnesComponents/TextDanger'
import Button from 'new-components/Button'
import { useHistory } from 'react-router'

import ContinueYourJourney from 'pages/AppointmentScheduling/ContinueYourJourney'
import AppointmentDetails from './AppointmentDetails'
import AppointmentConditions from './AppointmentConditions'
import * as Styled from './styles'

function PaymentStep() {
  const history = useHistory()
  const { brand, config } = useBrand()
  const { tokenApi } = useTokenApi()
  const isBranded = brand !== 'cannect'
  const { paidOrCanceledScheduling, resetContextValues, previousCheckoutStep } = useScheduling()
  // Logado, o checkout entra direto na Revisão (pulando Identificação) —
  // por isso previousCheckoutStep bloqueia a volta ao chegar em Pagamento
  // nesse caso (ver useScheduling). O botão fica oculto para não parecer quebrado.
  const canGoBack = isBranded && !tokenApi

  const statusName = paidOrCanceledScheduling?.current_status?.status_description?.name

  const statusTitle = statusName === 'canceled' ? 'Esse agendamento foi cancelado.' : 'Essa consulta já foi paga!'
  const statusDescription =
    statusName === 'canceled'
      ? 'O link de pagamento expirou. Para agendar uma nova consulta, clique no botão abaixo. <br/><br/> Se tiver alguma dúvida ou necessitar de auxílio, nossa equipe de suporte está disponível para ajudá-lo(a). <br/>Não hesite em entrar em contato conosco através do e-mail faleconosco@cannect.com.br'
      : 'Você receberá um e-mail de confirmação contendo o horário agendado e o link para acessar a sua consulta. <br/><br/>Se tiver alguma dúvida ou precise de assistência, nossa equipe de suporte está disponível para ajudá-lo(a). <br/>Não hesite em entrar em contato conosco através do e-mail faleconosco@cannect.com.br'

  const handleClick = () => {
    history.push(config.scheduling.path ?? '/agendamento')
    resetContextValues()
  }

  return (
    <>
      {canGoBack && !paidOrCanceledScheduling && (
        <button
          type="button"
          onClick={previousCheckoutStep}
          className="mb-4 flex items-center gap-2 border-none bg-transparent p-0 text-sm font-semibold text-neutral-700">
          <ArrowLeft className="size-4" />
          Voltar
        </button>
      )}
      <Styled.Container>
        {paidOrCanceledScheduling ? (
          <Styled.StatusWrapper style={{ gridArea: 'status' }}>
            <Styled.StatusTitle>{statusTitle}</Styled.StatusTitle>
            <TextDanger justify="center" text={statusDescription} />
            <Button onClick={handleClick}>Agendar outra consulta</Button>
            <ContinueYourJourney />
          </Styled.StatusWrapper>
        ) : (
          <>
            <BillingAddress />
            <AppointmentDetails />
            <Resume />
            <AppointmentConditions />
            <PaymentMethod />
          </>
        )}
      </Styled.Container>
    </>
  )
}

export default PaymentStep
